import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const BblPostWrapBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`${props.attributes.className ? props.attributes.className : ''} ${classes.postWrapper}`}>
        <div className="wrapper">
            {blocks.map((block) => {
                return block;
            })}
        </div>
    </div>
};

export const BblPostWrapBlockFragment = graphql`
  fragment BblPostWrapBlock on WpBlock {
    ... on WpBblPostWrapBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const BblPostWrapBlockPreview = `
    ... on BblPostWrapBlock {
        name
        attributes {
            className
        }
    }
`;